import { all, fork } from 'redux-saga/effects';

import globalSaga from 'containers/App/sagas';
import authProvider from 'utils/authProvider';

export default function* rootSaga() {
  yield all([fork(globalSaga(authProvider))]);
}
